module.exports = __webpack_public_path__ + "static/media/reserva_portada.247ceaac.png";